// extracted by mini-css-extract-plugin
export default {"answer":"_f2bb0ef3"};